import { createContext } from 'react';
import type { GlobalSearchTab } from '../../../server/types/search-types.ts';

export type GlobalSearchContextType = {
    openSearch: (defaultTab?: GlobalSearchTab) => void;
    open: boolean;
};

// this should be away from the global search provider, so it doesn't get
// recreated on HMR
export const GlobalSearchContext = createContext<GlobalSearchContextType | undefined>(undefined);
